import { Add } from "@mui/icons-material";
import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import NamePage from "src/components/shared/NamePage";
import TabComp from "src/components/shared/TabComp";
import TableComp from "src/components/shared/table/TableComp";
import useAppGlobal from "src/context/useAppGlobal";
import BankInfoForm from "./BankInfoForm";
import useBankInfoBody from "./hooks/useBankInfoBody";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";

const BankInfoPage = () => {
  const permissionCheck = useRoleCheck();
  const { handleOpenDialog } = useAppGlobal();
  const { header, bodyList, sortData, total } = useBankInfoBody();

  const handleCreateBankInfo = () => {
    handleOpenDialog({
      title: "Thêm tài khoản ngân hàng",
      size: "md",
      content: <BankInfoForm />,
    });
  };

  return (
    <React.Fragment>
      <NamePage
        name="Thiết lập thông tin thanh toán"
        subName="Thông tin tài khoản ngân hàng"
      />
      <Stack
        gap={1.5}
        my={1.5}
      >
        <Button
          disabled={!permissionCheck([PERMISSIONS.CREATE_BANKINFO])}
          onClick={handleCreateBankInfo}
          variant="contained"
          startIcon={<Add />}
          sx={{ width: "260px" }}
        >
          Thêm tài khoản ngân hàng
        </Button>
        <TabComp tabs={[{ id: "bank-info", name: "Tài khoản ngân hàng" }]} />
        <Box
          display="flex"
          gap="6px"
          alignItems="flex-start"
        >
          <Typography sx={{ fontWeight: "bold" }}>{total < 10 ? `0${total}` : total} tài khoản ngân hàng</Typography>
        </Box>
      </Stack>

      <TableComp
        dynamicWidth={"850px"}
        headers={header}
        sortData={sortData}
        bodyList={bodyList}
      />
    </React.Fragment>
  );
};

export default BankInfoPage;
